// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.supervisor_back_button {
    display: flex;
    justify-content: end;
    align-items: end;
    /* margin-left: 550px; */
}
.supervisor_back_button button {
    height: 40px;
    width: 120px;
    border-radius: 10px;
    border: none;
    background-color: #ddd;
    font-size: 16px;
    font-weight: 700;
}

.app_user_registration_form_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    /* min-height: 85vh; */
    background-color: #f9f9f9;
    /* padding: 20px; */
}
.app_user_registration_form {
    background: #ffffff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 400px;
    /* max-width: 400px; */
}

.app_user_registration_form_label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
    color: #333;
}

.app_user_registration_form_input {
    width: 100%;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.app_user_registration_form_input:focus {
    border-color: #ff5500;
    outline: none;
    box-shadow: 0 0 4px rgba(255, 98, 0, 0.3);
}

.app_user_registration_form_submit_button {
    width: 100%;
    padding: 10px;
    background-color: #e34004;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.app_user_registration_form_submit_button:hover {
    background-color: #bc2d02;
}

/* Responsive Design */

@media (max-width: 768px) {
    .app_user_registration_form {
        padding: 15px;
    }

    .app_user_registration_form_input {
        font-size: 13px;
    }

    .app_user_registration_form_submit_button {
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .supervisor_back_button {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 179px;
        margin-top: 15px;
    }

    .supervisor_back_button button {
        height: 20px;
        width: 80px;
        font-size: 12px;
    }

    .app_user_registration_form_wrapper {
        padding: 10px;
    }

    .app_user_registration_form {
        padding: 10px;
    }

    .app_user_registration_form_input {
        font-size: 12px;
        padding: 8px;
    }

    .app_user_registration_form_submit_button {
        font-size: 13px;
        padding: 8px;
    }
}

/* super visor table */
.add_supervisor_button {
    height: 40px;
    width: 130px;
    border: none;
    background-color: #0dada5;
    color: white;
    font-size: 15px;
    border-radius: 10px;
}

.supervisor_table_wrapper {
    width: 100%;
    overflow-x: auto;
    margin: 20px 0;
    padding: 10px;
}

.supervisor_table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 14px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
}

.supervisor_table_thead {
    background-color: #fdf3e3;
    color: rgb(228, 80, 0);
}

.supervisor_table th,
.supervisor_table td {
    padding: 10px 15px;
    text-align: left;
    border: 1px solid #ddd;
}

.supervisor_table th {
    font-weight: bold;
}

.supervisor_table_tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.supervisor_table_tbody tr:hover {
    background-color: #e0e0e0;
}

.supervisor_table ul {
    padding-left: 20px;
    margin: 0;
    list-style-type: disc;
}

.supervisor_table li {
    margin-bottom: 5px;
}

/* Responsive Design */
@media (max-width: 768px) {

    .supervisor_table th,
    .supervisor_table td {
        padding: 8px 10px;
        font-size: 12px;
    }

    .supervisor_table ul {
        padding-left: 15px;
    }

    .add_supervisor_button {
        height: 35px;
        width: 99px;
        border: none;
        background-color: #0dada5;
        color: white;
        font-size: 12px;
        border-radius: 10px;
    }
}

@media (max-width: 480px) {
    .supervisor_table_wrapper {
        margin: 10px 0;
    }

    .supervisor_table th,
    .supervisor_table td {
        padding: 6px 8px;
        font-size: 11px;
    }

    .supervisor_table ul {
        padding-left: 10px;
    }

    .add_supervisor_button {
        height: 30px;
        width: 99px;
        border: none;
        background-color: #0dada5;
        color: white;
        font-size: 12px;
        border-radius: 10px;
    }
}

/* add site css */

.selct_site_dropdown_conatiner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background-color: #fffbeb;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    width: 90%;
    max-width: 420px;
    padding: 25px;
    text-align: center;
    box-sizing: border-box;
    border: 2px solid #f6c90e;
}


.selct_site_dropdown_conatiner_close_button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    transition: color 0.3s ease;
}

.selct_site_dropdown_conatiner_close_button:hover {
    color: #e74c3c;
}

.selct_site_dropdown_heading {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #333;
}

.selct_site_dropdown_select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #333;
    background-color: #f9f9f9;
    box-sizing: border-box;
    transition: border-color 0.3s ease;
}

.selct_site_dropdown_select:focus {
    border-color: #db6334;
    outline: none;
}

.selct_site_dropdown_submit_button {
    padding: 10px 20px;
    background-color: #db7134;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
}

.selct_site_dropdown_submit_button:hover {
    background-color: #b95229;
}

@media (max-width: 768px) {
    .selct_site_dropdown_conatiner {
        width: 90%;
        padding: 15px;
    }

    .selct_site_dropdown_heading {
        font-size: 16px;
    }

    .selct_site_dropdown_select,
    .selct_site_dropdown_submit_button {
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .selct_site_dropdown_conatiner {
        width: 95%;
    }

    .selct_site_dropdown_heading {
        font-size: 14px;
    }
}

.alloted_site_button{
    height: 35px;
    width: 100px;
    background-color: #db6c34;
    border: none;
    border-radius: 5px;
    color: white;
}
.remove_site_button{
    height: 35px;
    width: 100px;
    background-color: #db3434;
    border: none;
    border-radius: 5px;
    color: white;  
    margin-left: 5px;
}
.delete_supervisor_button{
    height: 35px;
    width: 100px;
    background-color: rgb(255, 55, 0);
    border: none;
    border-radius: 5px;
    color: white;  
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Registration/appuserregistration.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;;AAEtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;AACJ;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;;IAEI;;QAEI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA,iBAAiB;;AAEjB;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,yBAAyB;IACzB,yCAAyC;IACzC,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;AAC7B;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".supervisor_back_button {\n    display: flex;\n    justify-content: end;\n    align-items: end;\n    /* margin-left: 550px; */\n}\n.supervisor_back_button button {\n    height: 40px;\n    width: 120px;\n    border-radius: 10px;\n    border: none;\n    background-color: #ddd;\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.app_user_registration_form_wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* min-height: 85vh; */\n    background-color: #f9f9f9;\n    /* padding: 20px; */\n}\n.app_user_registration_form {\n    background: #ffffff;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 400px;\n    /* max-width: 400px; */\n}\n\n.app_user_registration_form_label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: bold;\n    color: #333;\n}\n\n.app_user_registration_form_input {\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 20px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.app_user_registration_form_input:focus {\n    border-color: #ff5500;\n    outline: none;\n    box-shadow: 0 0 4px rgba(255, 98, 0, 0.3);\n}\n\n.app_user_registration_form_submit_button {\n    width: 100%;\n    padding: 10px;\n    background-color: #e34004;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.app_user_registration_form_submit_button:hover {\n    background-color: #bc2d02;\n}\n\n/* Responsive Design */\n\n@media (max-width: 768px) {\n    .app_user_registration_form {\n        padding: 15px;\n    }\n\n    .app_user_registration_form_input {\n        font-size: 13px;\n    }\n\n    .app_user_registration_form_submit_button {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 480px) {\n    .supervisor_back_button {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-left: 179px;\n        margin-top: 15px;\n    }\n\n    .supervisor_back_button button {\n        height: 20px;\n        width: 80px;\n        font-size: 12px;\n    }\n\n    .app_user_registration_form_wrapper {\n        padding: 10px;\n    }\n\n    .app_user_registration_form {\n        padding: 10px;\n    }\n\n    .app_user_registration_form_input {\n        font-size: 12px;\n        padding: 8px;\n    }\n\n    .app_user_registration_form_submit_button {\n        font-size: 13px;\n        padding: 8px;\n    }\n}\n\n/* super visor table */\n.add_supervisor_button {\n    height: 40px;\n    width: 130px;\n    border: none;\n    background-color: #0dada5;\n    color: white;\n    font-size: 15px;\n    border-radius: 10px;\n}\n\n.supervisor_table_wrapper {\n    width: 100%;\n    overflow-x: auto;\n    margin: 20px 0;\n    padding: 10px;\n}\n\n.supervisor_table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n}\n\n.supervisor_table_thead {\n    background-color: #fdf3e3;\n    color: rgb(228, 80, 0);\n}\n\n.supervisor_table th,\n.supervisor_table td {\n    padding: 10px 15px;\n    text-align: left;\n    border: 1px solid #ddd;\n}\n\n.supervisor_table th {\n    font-weight: bold;\n}\n\n.supervisor_table_tbody tr:nth-child(even) {\n    background-color: #f2f2f2;\n}\n\n.supervisor_table_tbody tr:hover {\n    background-color: #e0e0e0;\n}\n\n.supervisor_table ul {\n    padding-left: 20px;\n    margin: 0;\n    list-style-type: disc;\n}\n\n.supervisor_table li {\n    margin-bottom: 5px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n\n    .supervisor_table th,\n    .supervisor_table td {\n        padding: 8px 10px;\n        font-size: 12px;\n    }\n\n    .supervisor_table ul {\n        padding-left: 15px;\n    }\n\n    .add_supervisor_button {\n        height: 35px;\n        width: 99px;\n        border: none;\n        background-color: #0dada5;\n        color: white;\n        font-size: 12px;\n        border-radius: 10px;\n    }\n}\n\n@media (max-width: 480px) {\n    .supervisor_table_wrapper {\n        margin: 10px 0;\n    }\n\n    .supervisor_table th,\n    .supervisor_table td {\n        padding: 6px 8px;\n        font-size: 11px;\n    }\n\n    .supervisor_table ul {\n        padding-left: 10px;\n    }\n\n    .add_supervisor_button {\n        height: 30px;\n        width: 99px;\n        border: none;\n        background-color: #0dada5;\n        color: white;\n        font-size: 12px;\n        border-radius: 10px;\n    }\n}\n\n/* add site css */\n\n.selct_site_dropdown_conatiner {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1000;\n    background-color: #fffbeb;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    border-radius: 10px;\n    width: 90%;\n    max-width: 420px;\n    padding: 25px;\n    text-align: center;\n    box-sizing: border-box;\n    border: 2px solid #f6c90e;\n}\n\n\n.selct_site_dropdown_conatiner_close_button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    font-weight: bold;\n    color: #333;\n    cursor: pointer;\n    transition: color 0.3s ease;\n}\n\n.selct_site_dropdown_conatiner_close_button:hover {\n    color: #e74c3c;\n}\n\n.selct_site_dropdown_heading {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 20px;\n    color: #333;\n}\n\n.selct_site_dropdown_select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin-bottom: 20px;\n    font-size: 14px;\n    color: #333;\n    background-color: #f9f9f9;\n    box-sizing: border-box;\n    transition: border-color 0.3s ease;\n}\n\n.selct_site_dropdown_select:focus {\n    border-color: #db6334;\n    outline: none;\n}\n\n.selct_site_dropdown_submit_button {\n    padding: 10px 20px;\n    background-color: #db7134;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    width: 100%;\n}\n\n.selct_site_dropdown_submit_button:hover {\n    background-color: #b95229;\n}\n\n@media (max-width: 768px) {\n    .selct_site_dropdown_conatiner {\n        width: 90%;\n        padding: 15px;\n    }\n\n    .selct_site_dropdown_heading {\n        font-size: 16px;\n    }\n\n    .selct_site_dropdown_select,\n    .selct_site_dropdown_submit_button {\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 480px) {\n    .selct_site_dropdown_conatiner {\n        width: 95%;\n    }\n\n    .selct_site_dropdown_heading {\n        font-size: 14px;\n    }\n}\n\n.alloted_site_button{\n    height: 35px;\n    width: 100px;\n    background-color: #db6c34;\n    border: none;\n    border-radius: 5px;\n    color: white;\n}\n.remove_site_button{\n    height: 35px;\n    width: 100px;\n    background-color: #db3434;\n    border: none;\n    border-radius: 5px;\n    color: white;  \n    margin-left: 5px;\n}\n.delete_supervisor_button{\n    height: 35px;\n    width: 100px;\n    background-color: rgb(255, 55, 0);\n    border: none;\n    border-radius: 5px;\n    color: white;  \n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
